export default __webpack_public_path__ + "img/a7d462bd188dc6d9ff06bc8a8ab93d7e.jpg";